<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="布产"
      :page="false"
      show-checkbox
      :show-toolbar="false"
      :show-query="true"
      :get-data-func="clothProductionApi.list"
      :queryParamsAppend="queryParamsAppend"
      v-if="trendShow"
      :is-table="false"
      :isExecQuery="false"
      @query="queryFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="tabs">
        <el-tabs type="card" @tab-click="tabClick">
          <el-tab-pane label="待布产任务">
            <not-cloth ref="notCloth">
              <template slot="toolbar-right" v-if="$permission.canWrite()">
                <!-- <el-button type="primary" @click="openDialog"> 投产方案 </el-button> -->
                <el-button type="primary" @click="toSavePlan"> 新增布产 </el-button>
                <!-- <el-button type="primary" @click="toSavePlan">
                  保存布产
                </el-button> -->
              </template>
              <template slot="column">
                <el-table-column label="操作" fixed="right" align="center" width="160">
                  <template slot-scope="{ row }">
                    <el-button v-if="$permission.canWrite()" type="text" key="autoButton7" @click="buchan(row)">布产</el-button>
                    <el-button v-if="$permission.canRead()" type="text" key="autoButton8" @click="editPlan(row)">查看</el-button>
                    <el-button v-if="$permission.canWrite()" type="text" key="autoButton9" @click="del(row)">删除</el-button>
                  </template>
                </el-table-column>
              </template>
            </not-cloth>

            <!-- 投产方案 -->
            <put-dialog ref="putDialog"></put-dialog>
            <!-- 投产方案 -->
          </el-tab-pane>
          <el-tab-pane label="已布产任务">
            <already-cloth ref="alreadyCloth">
              <template slot="column">
                <el-table-column label="操作" fixed="right" align="center" width="200">
                  <template slot-scope="{ row }">
                    <el-button v-if="$permission.canRead()" type="text" key="autoButton1" @click="edit(row)">查看</el-button>
                    <el-button v-if="$permission.canWrite()" type="text" key="autoButton2" @click="cancel(row)">取消</el-button>
                    <el-button v-if="$permission.canReview() && row.Status === 0" type="text" key="autoButton3" @click="reviewCloth(row)">审核</el-button>
                    <el-button v-if="$permission.canReview() && row.Status === 1" type="text" key="autoButton4" @click="backCloth(row)">取消审核</el-button>
                    <!-- <el-button  key="autoButton5" type="text" @click="print(row)" v-if="row.IsContainInjection">
                      注塑工单合并打印
                    </el-button> -->
                    <!-- <el-button
                      v-if="$permission.canReview()  && row.Status === 1"
                      type="text"
                      key="autoButton5"
                      :disabled="row.IsOneClickGenerate"
                      @click="createWarehousingOrde(row)"
                      >一键生成入库单</el-button
                    > -->
                  </template>
                </el-table-column>
              </template>
            </already-cloth>
          </el-tab-pane>
          <!-- <el-tab-pane label="已完成">
            <completed ref="alreadyCloth">
              <template slot="column">
                <el-table-column
                  label="操作"
                  fixed="right"
                  align="center"
                  width="240"
                >
                  <template slot-scope="{ row }">
                    <el-button
                      v-if="$permission.canRead()"
                      type="text"
                      key="autoButton1"
                      @click="edit(row)"
                      >查看</el-button
                    >
                    <el-button
                      v-if="$permission.canWrite()"
                      type="text"
                      key="autoButton2"
                      @click="cancel(row)"
                      >取消</el-button
                    >
                    <el-button
                      v-if="$permission.canReview() && row.Status === 0"
                      type="text"
                      key="autoButton3"
                      @click="reviewCloth(row)"
                      >审核</el-button
                    >
                    <el-button
                      v-if="$permission.canReview()  && row.Status === 1"
                      type="text"
                      key="autoButton4"
                      @click="backCloth(row)"
                      >取消审核</el-button
                    >
                    <el-button
                      v-if="$permission.canReview()  && row.Status === 1"
                      type="text"
                      key="autoButton4"
                      @click="backCloth(row)"
                      >中止</el-button
                    >
                  </template>
                </el-table-column>
              </template>
            </completed>
          </el-tab-pane> -->
          <!-- <el-tab-pane label="终止布产任务">
            <stop-cloth ref="stopCloth">
              <template slot="column">
                <el-table-column
                  label="操作"
                  fixed="right"
                  align="center"
                  width="160"
                >
                  <template slot-scope="{ row }">
                    <el-button
                      v-if="$permission.canRead()"
                      type="text"
                      key="autoButton6"
                      @click="recovery(row)"
                      >恢复布产</el-button
                    >
                  </template>
                </el-table-column>
              </template>
            </stop-cloth>
          </el-tab-pane> -->
        </el-tabs>
        <cloth-dialog ref="editDialog"></cloth-dialog>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import curdMixins from '@/mixins/trend/curd'
import list from '@/components/common/trendsTable/list'
import notCloth from './notCloth'
import alreadyCloth from './alreadyCloth'
//import stopCloth from './stopCloth'
import putDialog from './putDialog'
import clothDialog from './clothDialog'
import completed from './completed'

export default {
  mixins: [listMixin, curdMixins],
  components: {
    list,
    notCloth,
    alreadyCloth,
    //stopCloth,
    putDialog,
    clothDialog,
    completed
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      clothProductionApi: require('@/api/production/clothProduction').default,

      trendShow: true,
      params: {
        Order: '',
        SubOrder: '',
        CustomerName: '',
        DocTime: '',
        StockName: '',
        Remark: '',
        Department: '',
        Salesman: ''
      },
      result: {},
      queryParamsAppend: {
        ProductionStatus: 0,
        ProductionStatuses:[0] 
      },
      currentData: [],
      currentIndex: 0
    }
  },
  mounted() {
    // this.$refs.notCloth._getData(this.params);
  },
  activated() {
    this.$nextTick(() => {
      this.$refs.notCloth.reload()
      this.$refs.alreadyCloth.reload()
      //this.$refs.stopCloth.reload();
    })
  },
  methods: {
    newPlan() {
      this.$router.push({
        name: 'addcloth'
      })
    },
    // 新增布产
    toSavePlan() {
      this.$router.push({
        name: 'savecloth'
      })
    },
    // 查看
    editPlan(row) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      let orderProductId = row.OrderProductId
      this.clothProductionApi.getInfo(orderProductId).then(res => {
        loading.close()
        if (res.Code === 0) {
          this.$router.push({
            name: 'savecloth',
            params: {
              data: row,
              resData: res.Data
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    tabClick({ index }) {
      console.log(index,"tabclick")
      switch (index) {
        case '0':
          this.queryParamsAppend.ProductionStatus = 0
          this.currentIndex = 0
          break
        case '1':
          this.queryParamsAppend.ProductionStatus=null;
          this.queryParamsAppend.ProductionStatuses = [1,2]
          this.currentIndex = 1
          break
        case '2':
          this.queryParamsAppend.ProductionStatus = 4
          this.currentIndex = 2
          break
      }
    },
    queryFunc(params) {
      console.log('params====', params)
      switch (this.currentIndex) {
        case 0:
          this.$refs.notCloth.queryFunc(params)
          break
        case 1:
          this.$refs.alreadyCloth.queryFunc(params)
          break
        case 2:
          //this.$refs.stopCloth.queryFunc(params)
          break
      }
    },
    createWarehousingOrde(row) {
      // 一键生成入库单

      let orderProductId = row.OrderProductId

      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })

      this.clothProductionApi
        .generateStInDoc({ orderProductId })
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$message.success(res.Msg)
            this.$refs.alreadyCloth.reload()
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    // start(row) {
    //   this.$refs.clothDialog.open();
    // },
    edit(row) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      let orderProductId = row.OrderProductId
      this.clothProductionApi.getInfo(orderProductId).then(res => {
        loading.close()
        if (res.Code === 0) {
          if (res.Data.RubberModels.length !== 0 || res.Data.WorkDocModels.length !== 0) {
            this.$router.push({
              name: 'editcloth',
              params: {
                data: row,
                resData: res.Data,
                isEdit: true
              }
            })
          } else {
            this.$router.push({
              name: 'editcloth',
              params: {
                data: row,
                resData: '',
                isEdit: true
              }
            })
          }
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    buchan(row) {
      if (row.ProductionDpId) {
        row.DpId = row.ProductionDpId
        row.DpName = row.ProductionDpName
      }
      if (row.clothremark) {
      }

      //  var loading = this.$loading({
      //     lock: true,
      //     text: "正在查询...",
      //     spinner: "el-icon-loading",
      //     customClass: "my_loading",
      //     background: "rgba(0, 0, 0, 0.3)",
      //   });
      //   let orderProductId = row.OrderProductId
      this.$router.push({
        name: 'editcloth',
        params: {
          data: row,
          resData: '',
          isEdit: false
        }
      })
      // this.clothProductionApi.getInfo(orderProductId).then(res => {
      //   loading.close();
      //   if(res.Code === 0){
      //     if(res.Data.RubberModels.length !== 0 || res.Data.WorkDocModels.length !== 0 ){
      //       this.$router.push({
      //         name: 'editcloth',
      //         params: {
      //           data: row,
      //           resData: res.Data
      //         }
      //       })
      //     }else{

      //     }

      //   }else{
      //     this.$message({type: 'warning', message: res.Msg})

      //   }
      // })
    },
    end({ OrderProductId }) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.clothProductionApi
        .stopCloth({ id: OrderProductId })
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$message({ type: 'success', message: '操作成功' })
            this.$refs.notCloth.reload()
            //this.$refs.stopCloth.reload();
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    del({ OrderProductId }) {
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var loading = this.$loading({
            lock: true,
            text: '正在查询...',
            spinner: 'el-icon-loading',
            customClass: 'my_loading',
            background: 'rgba(0, 0, 0, 0.3)'
          })
          this.clothProductionApi
            .removeCloth({ id: OrderProductId })
            .then(res => {
              loading.close()
              if (res.Code === 0) {
                this.$message({ type: 'success', message: res.Msg })
                this.$refs.notCloth.reload()
                //this.$refs.stopCloth.reload();
              } else {
                this.$message({ type: 'warning', message: res.Msg })
              }
            })
            .catch(err => {
              loading.close()
            })
        })
        .catch(() => {})
    },
    openDialog() {
      this.$refs.putDialog.open().then(that => {
        that.setWarehouseList()
      })
    },
    print(row) {
      let newpage = this.$router.resolve({
        path: '/clothPrint?id=' + row.OrderProductId
      })
      window.open(newpage.href, '_blank')
    },
    reviewCloth({ OrderProductId }) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.clothProductionApi
        .reviewCloth({ id: OrderProductId })
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.$refs.alreadyCloth.reload()
            // this.$refs.notCloth.reload();
            // this.$refs.stopCloth.reload();
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    backCloth({ OrderProductId }) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.clothProductionApi
        .backCloth({ id: OrderProductId })
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.$refs.alreadyCloth.reload()
            // this.$refs.notCloth.reload();
            // this.$refs.stopCloth.reload();
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    view(row) {},
    cancel({ OrderProductId }) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.clothProductionApi
        .cancelCloth({ id: OrderProductId })
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.$refs.notCloth.reload()
            this.$refs.alreadyCloth.reload()
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    check(row) {},
    cancelCheck(row) {},
    recovery({ OrderProductId }) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.clothProductionApi
        .recoveryCloth({ id: OrderProductId })
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$message({ type: 'success', message: '操作成功' })
            this.$refs.notCloth.reload()
            //this.$refs.stopCloth.reload();
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          loading.close()
        })
    }
  }
}
</script>
